// Generated by https://quicktype.io

export class GiftCardDto {
	GiftCardID: string;
	CorpID: number;
	AcctNo: string;
	Pin: number | null;
	Issued: boolean;
	IssuedByStoreId: string;
	Memo: string;
	ExpirationDate: null;
	created: string;
	transactions?: Transaction[];

	public constructor(init?: Partial<GiftCardDto>) {
		Object.assign(this, init);
	}
}

export class Transaction {
	TransactionID: string;
	TranDateTime: string;
	CorpID: number;
	StoreID: number;
	IpPort: string;
	UserID: string;
	Pin: string;
	GiftCardID: string;
	OperatorID: string;
	TranType: string;
	TranCode: string;
	Memo: string;
	RefNo: string;
	Track2: string;
	AcctNo: string;
	Purchase: number;
	Authorize: number;
	DSIXReturnCode: string;
	CmdStatus: string;
	TextResponse: string;
	UserTraceData: string;
	ResponseOrigin: string;
	CardPin: number;
	Voided: boolean;

	public constructor(init?: Partial<Transaction>) {
		Object.assign(this, init);
		switch (this.TranCode) {
			case "VoidIssue":
				this.TranCode = "Void";
				break;
			case "VoidReload":
				this.TranCode = "Void";
				break;
			case "VoidSale":
				this.TranCode = "Void";
				break;
			case "Sale":
				this.TranCode = "Redeem";
				break;
			case "NoNSFSale":
				this.TranCode = "Redeem";
				break;
			case "Sale-Redeem-Tip":
				this.TranCode = "Redeem";
				break;
			case "Issue":
				this.TranCode = "Issue";
				break;
			case "Reload":
				this.TranCode = "Issue";
				break;
			default:
				break;
		}
	}
}
